enum ConditionTypes {
  Equal = '=',
  Range = 'RANGE',

  // TODO: Not in use for now.
  // LessThan = '<',
  // LessOrEqualThan = '=<',
  // GreaterThan = '>',
  // GreaterOrEqualThan = '>=',
  // Contains = 'CONTAINS',
}

export default ConditionTypes;
export type VerifyConditionTypes = Utils.VerifyExtends<Model.Enum.ConditionTypes, Utils.ValueOf<typeof ConditionTypes>>;
